import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Session } from 'src/app/models/session';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {

  constructor(private service: UserService, private toast: ToastrService, private session: Session) { }

  config: any = {};

  ngOnInit() {
    this.getConfig();
  }

  getConfig(){
    this.service.getConfig().subscribe(d=>{
      console.log("CONFIG",d);
      this.config = d;
      delete this.config._id;
      delete this.config.__v;

    })
  }

  guardar(){
    this.service.postConfig(this.config).subscribe(d=>{
      this.toast.success("GUARDADO");
    }, er=>{
      this.toast.error("ERROR");
    })
  }

  testWhatsapp(){
    var phone = prompt("Ingresa el número de mensaje a realizar la prueba. Sin el +54 ni espacios. Ej: 1161616060 ");
    if(!phone || phone.length<6){
      alert("Telefono invallido");
      return;
    }
    this.service.testWhatsapp(phone, this.session.user.name).subscribe(d=>{
      this.toast.success("Enviado");
    }, er=>{
      this.toast.error("ERROR");
    })
  }


  eliminarAsignaciones(){
    if(confirm("Esta seguro que desea eliminar TODAS LAS ASIGNACIONES")){
      this.service.eliminarTodasLasAsignaciones().subscribe(d=>{
        this.toast.success("Eliminación completada");
      })
    }
  }

  eliminarTickets(){
    if(confirm("Esta seguro que desea eliminar TODOS LOS TICKETS")){
      this.service.eliminarTodosLosTickets().subscribe(d=>{
        this.toast.success("Eliminación completada");
      })
    }
  }

  eliminarSolicitudes(){
    if(confirm("Esta seguro que desea eliminar TODAS LAS SOLICITUDES DE REPUESTOS")){
      this.service.eliminarTodasLasSolicitudes().subscribe(d=>{
        this.toast.success("Eliminación completada");
      })
    }
  }


  

}
